import { render, staticRenderFns } from "./bookReview.vue?vue&type=template&id=9975cbcc&scoped=true&"
import script from "./bookReview.vue?vue&type=script&lang=js&"
export * from "./bookReview.vue?vue&type=script&lang=js&"
import style0 from "./bookReview.vue?vue&type=style&index=0&id=9975cbcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975cbcc",
  null
  
)

export default component.exports